import { cookieService } from "./cookie";

export function setUserLocalStorage(userData) {
	cookieService.set("si-token", "1234");
	window.localStorage.setItem("userInfo", JSON.stringify(userData));
	return true;
}

export const getUserLocalStorage = () => {
	const userInfo = window.localStorage.getItem("userInfo");
	if (userInfo !== null || userInfo !== "") {
		const userInfoObj = JSON.parse(userInfo);
		return userInfoObj;
	} else {
		return null;
	}
};

export const getUserId = () => {
	const userInfo = getUserLocalStorage();
	let userId = "";
	if (userInfo !== null) {
		if (userInfo.userId !== undefined && userInfo.userId !== "") {
			userId = userInfo.userId;
		}
	}
	return userId;
};

export const getAccessToken = () => {
	const userInfo = getUserLocalStorage();
	if (userInfo && userInfo.accessToken) {
		return userInfo.accessToken;
	}
	return "";
};

export const getRefreshToken = () => {
	const userInfo = getUserLocalStorage();
	if (userInfo && userInfo.refreshToken) {
		return userInfo.refreshToken;
	}
	return "";
};

export const clearUserLocalStorage = () => {
	window.localStorage.removeItem("userInfo");
	cookieService.erase("si-token");
};

export const updateTokensInLocalStorage = ({ accessToken, refreshToken, expiresIn }) => {
	const userInfo = getUserLocalStorage() || {};
	const next = {
		...userInfo,
		...(accessToken !== undefined && { accessToken }),
		...(refreshToken !== undefined && { refreshToken }),
		...(expiresIn !== undefined && { expiresIn }),
	};
	window.localStorage.setItem("userInfo", JSON.stringify(next));
	return next;
};
